import React from "react";
import {
  Container,
  Paper,
  Box,
  Typography,
  Alert,
  Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { S3FilterProvider } from "../../contexts/S3FilterContext";
import { FilteredS3Browser } from "../s3/FilteredS3Browser";
import { useAuth } from "../../contexts/AuthContext";
import { themeColors } from "../../utils/theme";

/**
 * MailerReports Component
 *
 * Standalone page component for reports download functionality.
 * Provides S3 file browser access for downloading reports files.
 * Requires authentication to access.
 */
const MailerReports: React.FC = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  // Show access denied if not authenticated
  if (!currentUser) {
    return (
      <Container maxWidth="sm">
        <Box sx={{ mt: 8, mb: 4 }}>
          <Paper
            elevation={3}
            sx={{
              p: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
              Access Denied
            </Typography>
            <Alert severity="error" sx={{ width: "100%", mb: 2 }}>
              You must be logged in to access this page
            </Alert>
            <Button
              variant="contained"
              sx={{ bgcolor: themeColors.primary }}
              onClick={() => navigate("/login")}
            >
              Go to Login
            </Button>
          </Paper>
        </Box>
      </Container>
    );
  }

  return (
    <Box sx={{ mb: 4 }}>
      <Paper
        elevation={3}
        sx={{
          bgcolor: themeColors.paper,
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        <S3FilterProvider>
          <Box
            sx={{
              p: { xs: 2, sm: 2, md: 2 },
              pl: { xs: 2, sm: 3, md: 3 },
              pr: { xs: 2, sm: 3, md: 4 },
              minHeight: "70vh",
            }}
          >
            <Typography
              variant="h6"
              sx={{
                mb: 3,
                color: themeColors.primary,
                fontWeight: 600,
              }}
            >
              Finanical Reporting Download
            </Typography>
            <FilteredS3Browser basePath="" />
          </Box>
        </S3FilterProvider>
      </Paper>
    </Box>
  );
};

export default MailerReports;
